<div class="texto" style="margin-top: 3vh;">
    En el momento del <b>ingreso</b> de internación se va a identificar a el/ la paciente mediante una pulsera. <br>

    En el momento del <b>egreso</b> cuando el/ la paciente tenga firmada el alta médica, Enfermería avisará a un/a familiar para que gestione el alta administrativa. 
</div>

    

